export class PasswordVault {
    name: string;
    description: string;
    vaultType: number;
    version: number;
}